import { useQuery } from "@tanstack/react-query";
import {
  fetchAllDownloadableContent,
  fetchActiveDownloadableContent,
  fetchDownloadableContentById,
  getDownloadUrl,
  getThumbnailDownloadUrl,
} from "./downloadable-content.api";
import { DownloadableContent } from "@/entities/downloadable-content";

const QUERY_KEYS = {
  all: ["downloadable-content"],
  active: ["downloadable-content", "active"],
  byId: (id: string) => ["downloadable-content", id],
  downloadUrl: (id: string) => ["downloadable-content", id, "download-url"],
  thumbnailUrl: (id: string) => ["downloadable-content", id, "thumbnail-url"],
};

/**
 * 모든 다운로드 가능한 콘텐츠 조회
 */
export const useDownloadableContents = (active?: boolean) => {
  return useQuery({
    queryKey:
      active !== undefined ? [...QUERY_KEYS.all, active] : QUERY_KEYS.all,
    queryFn: () => fetchAllDownloadableContent(active),
    staleTime: 1000 * 60 * 5, // 5분
  });
};

/**
 * 활성 콘텐츠만 조회
 */
export const useActiveDownloadableContents = () => {
  return useQuery({
    queryKey: QUERY_KEYS.active,
    queryFn: fetchActiveDownloadableContent,
    staleTime: 1000 * 60 * 5,
  });
};

/**
 * 단일 콘텐츠 조회
 */
export const useDownloadableContent = (id: string) => {
  return useQuery({
    queryKey: QUERY_KEYS.byId(id),
    queryFn: () => fetchDownloadableContentById(id),
    enabled: !!id,
    staleTime: 1000 * 60 * 5,
  });
};

/**
 * 파일 다운로드 URL 조회
 */
export const useDownloadUrl = (id: string) => {
  return useQuery({
    queryKey: QUERY_KEYS.downloadUrl(id),
    queryFn: () => getDownloadUrl(id),
    enabled: !!id,
    staleTime: 1000 * 60, // 1분
  });
};

/**
 * 썸네일 다운로드 URL 조회
 */
export const useThumbnailDownloadUrl = (id: string) => {
  return useQuery({
    queryKey: QUERY_KEYS.thumbnailUrl(id),
    queryFn: () => getThumbnailDownloadUrl(id),
    enabled: !!id,
    staleTime: 1000 * 60, // 1분
  });
};
